import { QueryOptions, useQuery, UseQueryResult } from '@tanstack/react-query';
import { IXeroSignUpResponse } from '../types';
import { XERO_QUERY_KEYS } from './keys';
import { fetchXeroSignupUrl } from './services';

export const useXeroSignupUrlQuery = ({
  options,
}: {
  options?: QueryOptions;
} = {}): UseQueryResult<IXeroSignUpResponse> =>
  useQuery({
    queryKey: [XERO_QUERY_KEYS.GET_XERO_SIGNUP_URL],
    refetchOnWindowFocus: false,
    retry: false,
    queryFn: ({ signal }) => fetchXeroSignupUrl({ signal }),
    ...options,
  }) as UseQueryResult<IXeroSignUpResponse>;
